// filepath: /home/chilikl/pangea/pangea-frontend/reader-app/src/OtiContext.js
import { createContext, useContext } from "react";

// Create context with a default value
const OtiContext = createContext({
  openCookiePreferences: null
});

// Custom hook for consuming the context easily
export const useOti = () => useContext(OtiContext);

export default OtiContext;
